import React from "react";
import "./index.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
